import { render, staticRenderFns } from "./FamiliaProduto.vue?vue&type=template&id=c4bcc208"
import script from "./FamiliaProduto.vue?vue&type=script&lang=js"
export * from "./FamiliaProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports